import { render, staticRenderFns } from "./ScheduleWorkspace.vue?vue&type=template&id=5c06c1e2&scoped=true"
import script from "./ScheduleWorkspace.vue?vue&type=script&lang=js"
export * from "./ScheduleWorkspace.vue?vue&type=script&lang=js"
import style0 from "./ScheduleWorkspace.vue?vue&type=style&index=0&id=5c06c1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c06c1e2",
  null
  
)

export default component.exports